﻿import type {BusyOptions, PromisableEvent} from "../types";

export const createPromisableEvent = <T=any>(event:Event):PromisableEvent => ({
    sourceEvent: event,
    target: event.target as Node,
    preventDefault: () => event.preventDefault(),
    stopPropagation: () => event.stopPropagation(),
    stopImmediatePropagation: () => event.stopImmediatePropagation(),
    setPromise: <T>(promise: Promise<T>, options?: BusyOptions) => Promise.resolve<T>(<any>undefined)
})